// extracted by mini-css-extract-plugin
module.exports = {"modalBody":"Previews_modalBody__2W1QB","pre_box":"Previews_pre_box__3BUBw"};